import { usePageStateMemory } from "./usePageStateMemory.js";

export function useSessionStorageState(key, fallbackValue = "") {
  return usePageStateMemory(key, fallbackValue);
}
